<script>
import {defineComponent} from 'vue'
import ClSlider from "@/components/base/ClSliderCircular.vue";
import ClAdvertiseSliderItem from "@/components/home/ClAdvertiseSliderItem.vue";

export default defineComponent({
  name: "ClAdvertiseSlider",
  components: {ClAdvertiseSliderItem, ClSlider},
  data(){
    return {
      options: {
        xs: {
          itemToShow: 2,
          itemToSlide:2,
        },
        sm: {
          itemToShow: 3,
          itemToSlide: 3
        },
        md: {
          itemToShow: 4,
          itemToSlide: 4
        },
        lg: {
          itemToShow: 5,
          itemToSlide: 1
        },
        xl: {
          itemToShow: 5,
          itemToSlide: 1
        }
      },
      items: [
        {
          link: "https://www.zoomit.ir/2018/10/18/298271/classino-online-learrn/",
          name: "خبرگزاری زومیت",
          img: "zoomit.png",
          alt: "classino zoomit",
        },
        {
          link: "https://www.tabnak.ir/fa/news/842729/%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF%D8%A7%D9%86%D9%87-%D9%88-%D8%A8%D8%A7%DA%A9%DB%8C%D9%81%DB%8C%D8%AA%E2%80%8C%D8%AA%D8%B1%DB%8C%D9%86-%D8%A2%D9%85%D9%88%D8%B2%D8%B4%DA%AF%D8%A7%D9%87-%D8%A2%D9%86%D9%84%D8%A7%DB%8C%D9%86-%DA%A9%D9%86%DA%A9%D9%88%D8%B1",
          name: "خبرگزاری تابناک",
          img: "tabnak.png",
          alt: "classino tabnak",
        },
        {
          link: "https://dgto.ir/138u",
          name: "خبرگزاری دیجیاتو",
          img: "digiato.png",
          alt: "classino digiato",
        },
        {
          link: "http://akharinkhabar.ir/sport/4568711",
          name: "خبرگزاری آخرین خبر",
          img: "akharinkhabar.png",
          alt: "classino akharin khabar",
        },
        {
          link: "http://www.asriran.com/fa/news/636087/%DA%A9%D9%84%D8%A7%D8%B3%DB%8C%D9%86%D9%88-%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF%D8%A7%D9%86%D9%87-%D9%88-%D8%A8%D8%A7%DA%A9%DB%8C%D9%81%DB%8C%D8%AA-%D8%AA%D8%B1%DB%8C%D9%86-%D8%A2%D9%85%D9%88%D8%B2%D8%B4%DA%AF%D8%A7%D9%87-%D8%A2%D9%86%D9%84%D8%A7%DB%8C%D9%86-%DA%A9%D9%86%DA%A9%D9%88%D8%B1",
          name: "خبرگزاری عصر ایران",
          img: "asreiran.png",
          alt: "classino asre iran",
        },
        {
          link: "https://www.mehrnews.com/",
          name: "خبرگزاری مهر",
          img: "mehrnews.png",
          alt: "classino mehr",
        },
        {
          link: "https://www.afkarnews.com/",
          name: "افکار نیوز",
          img: "afkarnews.png",
          alt: "classino afkar news"
        },
        {
          link: "https://www.ilna.ir/",
          name: "ایلنا",
          img: "ilna.png",
          alt: "classino ilna"
        },
        {
          link: "https://www.jahannews.com/",
          name: "جهان نیوز",
          img: "jahannews.png",
          alt: "classino jahan news"
        },
        {
          link: "https://www.hamshahrionline.ir/",
          name: "همشهری آنلاین",
          img: "hamshahrionline.png",
          alt: "classino hamshahri online"
        },
        {
          link: "https://www.khabaronline.ir/",
          name: "خبر آنلاین",
          img: "khabaronline.png",
          alt: "classino khabar online"
        },
      ]
    }
  },
})
</script>

<template>
 <v-container>
   <ClSlider :items="items" :break-points="options" :hide-arrows="true" >
     <template #item="{item}">
       <ClAdvertiseSliderItem :item="item" />
     </template>
   </ClSlider>
 </v-container>
</template>

<style scoped lang="scss">

</style>